import { useAuth } from '../../contexts/AuthContext/AuthContext'

export default function CompanyInfo() {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return (
      <div>
        <h1>Authentication Required</h1>
        <p>Please log in to access company information.</p>
      </div>
    )
  }

  return (
    <div>
      <h1>Company Information</h1>
      <p>Welcome to your company information!</p>
    </div>
  )
} 